import hb from "handlebars/dist/handlebars"
import cloneDeep from "lodash.clonedeep"

function reduceDeepBoolean(payload) {
  //console.log("REDUCIENDO", payload)

  if (payload) {
    const conditions =
      Array.isArray(payload) ||
      typeof payload === "string" ||
      typeof payload === "boolean"

    const normalizedPayload = conditions ? payload : Object.values(payload)

    const result = Array.isArray(normalizedPayload)
      ? normalizedPayload.reduce((a, b) => {
          const bValidation =
            typeof b === "boolean"
              ? b
              : Object.values(b).reduce((c, d) => {
                  return c && d
                }, [])
          return a && bValidation
        }, [])
      : normalizedPayload

    return result
  } else {
    return false
  }
}

export function digger(payload, coordinates) {
  const { param, parent, key, debug } = coordinates || {}

  if (debug)
    console.log(
      "IM GONNA DIG",
      payload,
      coordinates,
      this && this.getValue ? this.getValue : "NO 'THIS' CONTEXT"
    )
  const evaluatedParam = this && this.getValue ? this.getValue(param) : param
  const evaluatedParent = this && this.getValue ? this.getValue(parent) : parent //
  const evaluatedKey = this && this.getValue ? this.getValue(key) : key //
  if (debug)
    console.log(
      "DIGGING",
      payload,
      coordinates,
      evaluatedParam,
      evaluatedParent,
      evaluatedKey
    )
  const diggedValue = payload
    ? coordinates
      ? evaluatedParam
        ? evaluatedKey
          ? evaluatedParent
            ? payload[evaluatedParam] !== undefined &&
              payload[evaluatedParam][evaluatedParent] !== undefined &&
              payload[evaluatedParam][evaluatedParent][evaluatedKey] !==
                undefined
              ? payload[evaluatedParam][evaluatedParent][evaluatedKey]
              : undefined
            : payload[evaluatedParam] !== undefined &&
              payload[evaluatedParam][evaluatedKey] !== undefined
            ? payload[evaluatedParam][evaluatedKey]
            : undefined
          : payload[evaluatedParam] !== undefined
          ? payload[evaluatedParam]
          : undefined
        : payload
      : payload
    : undefined

  if (debug) console.log("DIGGED", diggedValue)

  return diggedValue
}

function JSONparse(payload) {
  //console.log("JSON PARSING", payload)
  const parsedJSON = payload ? JSON.parse(payload) : undefined
  const result = parsedJSON ?? undefined
  return result
}

function JSONstringify(payload) {
  //console.log("JSON STRINGIFY", payload)
  const stringifiedJSON = payload ? JSON.stringify(payload) : undefined
  const result = stringifiedJSON ?? undefined
  return result
}

function indexSelector(payload, i) {
  //console.log("SLECTING INDEX", payload, i)
  if (payload && payload[i]) {
    return payload[i]
  } else {
    return false
  }
}

function addPrefixSufix(payload, param) {
  const { prefix, sufix, separator, debug } = param
  const evaluatedPrefix =
    prefix && this.getValue(prefix)
      ? `${this.getValue(prefix)}${separator ?? ""}`
      : ""
  const evaluatedSufix =
    sufix && this.getValue(sufix)
      ? `${separator ?? ""}${this.getValue(sufix)}`
      : ""
  const result = `${evaluatedPrefix ?? ""}${payload}${evaluatedSufix ?? ""}`
  if (debug) console.log("HOLIS desde PrefixSufix", payload, param, result)
  return result
}

function objectValues(payload) {
  if (payload && typeof payload == "object" && !Array.isArray(payload)) {
    return Object.values(payload)
  } else {
    return false
  }
}

function lengthCheck(payload, param) {
  const compareNumber =
    param && param.number && Number(param.number)
      ? Number(param.number)
      : param ?? 0
  let result
  if (payload && typeof payload == "object" && !Array.isArray(payload)) {
    /* console.log(
      "CHECKING OBJECT VALUES LENGTH",
      payload,
      param,
      Object.values(payload).length,
      compareNumber
    ) */
    result = Object.values(payload).length > compareNumber
  } else if (payload && typeof payload == "object" && Array.isArray(payload)) {
    /* console.log(
      "CHECKING ARRAY LENGTH",
      payload,
      param,
      payload.length,
      compareNumber
    ) */
    result = payload.length > compareNumber
  } else if (
    payload &&
    (typeof payload == "number" ||
      (typeof payload == "string" && Number(payload)))
  ) {
    /* console.log(
      "CHECKING NUMBER LENGTH",
      payload,
      param,
      payload.length,
      compareNumber
    ) */
    result = payload > compareNumber
  } else {
    //console.log("UNKWNOWN PAYLOAD", payload, param, compareNumber)

    result = false
  }
  //console.log("LENGTH CHECKWER RESULT", result)
  return result
}

function minorTo(a, b) {
  if (a && b) {
    return a < b
  } else {
    return undefined
  }
}

function greaterTo(a, b) {
  // console.log("IN GREATER TO", a, b, a > b)
  if (a && b) {
    return a > b
  } else {
    return undefined
  }
}

function findByCoordinates(payload, param) {
  const { debug } = param ?? {}
  if (debug) console.log("finding", payload, param)
  if (payload && Array.isArray(payload) && lengthCheck(payload)) {
    const result = payload.find((option) => {
      const validation = this.getValue(param, option)
      if (debug) {
        if (validation) console.log("PASE VALIDACION", validation)
        else console.log("NO PASE VALIDACION", param, option)
      }
      return validation
    })

    if (debug) console.log("found", result)
    return result
  } else {
    if (debug) console.log("cant find")
    return false
  }
}

function formatCurrency(payload, param) {
  const { debug, currency, locale } = param ?? false
  if (debug) console.log("STARTING TO FORMARTTT", payload)
  let result
  const evaluatedCurrency =
    currency ??
    this.$store.getters.index({
      param: "zone",
      key: "currency"
    })
  const evaluatedLocale =
    locale ?? this.$store.getters.index({ param: "locale" })

  if (payload) {
    if (typeof payload == "object") {
      result = payload[evaluatedCurrency]
    } else {
      result = payload
    }

    return Number(result).toLocaleString(
      evaluatedLocale.code + "-" + evaluatedLocale.iso2,
      {
        style: "currency",
        currency: evaluatedCurrency,
        currencyDisplay: "symbol",
        maximumFractionDigits: evaluatedCurrency == "COP" ? 0 : 2,
        minimumFractionDigits: evaluatedCurrency == "COP" ? 0 : 2
      }
    )
  } else {
    return false
  }
}

function toNumber(payload) {
  return Number(payload)
}

function splitter(payload, param) {
  return payload ? payload.split(param) : undefined
}

function objectCreator(payload, params) {
  const paramsKeys = Object.keys(params)
  let filteredPayload = cloneDeep(payload)
  delete filteredPayload.debug
  delete filteredPayload.util
  const paramsObjects = paramsKeys.reduce(
    (accumulator, current) => {
      return { ...accumulator, [current]: this.getValue(params[current]) }
    },
    { ...filteredPayload }
  )
  if (params.debug)
    console.log(
      "HANDLING OBJECT CREATION",
      payload,
      filteredPayload,
      params,
      paramsObjects
    )

  return paramsObjects
}

function handlebars(payload, params) {
  const paramsKeys = Object.keys(params)
  const paramsObjects = paramsKeys.reduce((accumulator, current) => {
    return { ...accumulator, [current]: this.getValue(params[current]) }
  }, {})
  //const evaluatedParam = this.getValue(param)
  if (params.debug)
    console.log("HANDLING HANDDLE", payload, params, paramsObjects)
  const template = hb.compile(payload)
  return template(paramsObjects)
}

function slugify(string) {
  const a =
    "àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;"
  const b =
    "aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------"
  const p = new RegExp(a.split("").join("|"), "g")
  const formatted = string
    ? string
        .toString()
        .toLowerCase()
        .replace(/\s+/g, "-") // Replace spaces with -
        .replace(p, (c) => b.charAt(a.indexOf(c))) // Replace special characters
        .replace(/&/g, "-and-") // Replace & with 'and'
        .replace(/[^\w-]+/g, "") // Remove all non-word characters
        .replace(/--+/g, "-") // Replace multiple - with single -
        .replace(/^-+/, "") // Trim - from start of text
        .replace(/-+$/, "") // Trim - from end of text
    : ""
  //console.log("SLUGING",string, formatted)
  return formatted
}

function addSlashEnd(string) {
  return string + "/"
}

function mediaUrlMaker({ site, media, version }) {
  //console.log("MEDIA URL MAKER", site, media, version)
  const availableMedia =
    media !== undefined ? media : site.business?.media ?? false
  const finalMedia =
    availableMedia &&
    availableMedia.id &&
    (availableMedia.date_string || availableMedia.createdAt)
      ? `https://cdn.${site.domain}/${site.domain}/${media.author.role}/${
          availableMedia.date_string || availableMedia.createdAt.split("T")[0]
        }/${availableMedia.id}${version && version == "original" ? "_o" : ""}.${
          availableMedia.format ? availableMedia.format : "jpg"
        }`
      : `/images/icons/image-placeholder.svg`
  return finalMedia
}

function labelUrlMaker({ site, order, index, isReturn = false }) {
  const { domain } = site
  const { shipping_metadata, return_metadata, customer, _id: orderId } = order
  const customerId = customer?._id || customer

  let labelFilename = null

  if (isReturn) {
    labelFilename = return_metadata[index]?.label_file_name
  } else {
    labelFilename = shipping_metadata[index]?.label_file_name
  }

  const labelUrl = `https://cdn.${domain}/${domain}/orders/${customerId}/${orderId}/labels/${labelFilename}`

  return labelUrl
}

async function toDataURL(url) {
  //console.log("ABOUT TO END b64 ", url)
  const result = await fetch(url)
    .then((response) => response.blob())
    .then(
      (blob) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.onloadend = () => resolve(reader.result)
          reader.onerror = reject
          reader.readAsDataURL(blob)
        })
    )
  //console.log("ABOUT TO END b64 ", url, result)
  return result
} /* 
function toDataURL(url) {
  return fetch(url)
    .then((response) => response.blob())
    .then(
      (blob) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.onloadend = () => resolve(reader.result)
          reader.onerror = reject
          reader.readAsDataURL(blob)
        })
    )
} */

function dateToLocaleString(timestamp) {
  const date = new Date(timestamp)
  return date.toLocaleString()
}

function isJson(text, param) {
  const { debug } = param ?? {}
  if (typeof text !== "string") {
    return false
  }
  try {
    const hasObjectOrArraySymbols = text.includes("{") || text.includes("[")
    const result = hasObjectOrArraySymbols ? JSON.parse(text) : false
    if (debug) console.log("IS JSON", result)
    return result
  } catch (error) {
    return false
  }
}

export default {
  reduceDeepBoolean,
  digger,
  JSONparse,
  JSONstringify,
  indexSelector,
  addPrefixSufix,
  objectValues,
  lengthCheck,
  minorTo,
  greaterTo,
  findByCoordinates,
  formatCurrency,
  toNumber,
  objectCreator,
  splitter,
  handlebars,
  slugify,
  addSlashEnd,
  mediaUrlMaker,
  labelUrlMaker,
  toDataURL,
  dateToLocaleString,
  isJson
}
